<div style="padding-bottom: 1em;" class="close-button">
    <svg-icon src="assets/svgs/close_black_24dp.svg" style="float: right;" (click)="onNoClick()" class="close-button-icon"></svg-icon>
</div>

